import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";

import { NewsCard } from "../../components/features/News/NewsCard/NewsCard";
import { newsSelector } from "../../redux/news/newsSlice";

const News = () => {
  const { news } = useSelector(newsSelector);

  return (
    <main
      className="flex min-h-screen mx-auto text-white touch-device:pb-8 touch-device:pt-8"
      style={{
        background:
          "linear-gradient(180deg, #1C2A37 0%, #161C21 100%), #1D1D1D",
      }}
    >
      <Helmet>
        <title>EA FC 25 News - EasySBC</title>
        <link rel="canonical" href="https://www.easysbc.io/news" />
        <meta
          name="description"
          content="Keep up to date with the latest news and updates from EA FC 25 and EasySBC"
        />
      </Helmet>
      <div className="flex flex-col w-full mx-auto rounded-md desktop:p-8 desktop:w-fit gap-y-4 desktop:gap-y-8 px-0 bg-white/10 touch-device:min-w-[950px]">
        <div className="flex flex-col text-left gap-y-3 p-6 mobile:p-0">
          <h1 className="font-semibold text-xl touch-device:text-4xl touch-device:px-0">
            EA FC 25 News
          </h1>
          <h2 className="max-w-[660px] touch-device:max-w-[916px] text-xs mobile:text-base">
            Get the latest EA Sports FC 25 news, tips, and releases from
            EasySBC. Stay ahead with insights from our pro experts and access
            exclusive data on FC 25 trends.
          </h2>
          <div className="grid justify-center gap-4 py-4 touch-device:grid-cols-2 touch-device:rounded-lg touch-device:mt-6">
            {news.map((n) => (
              <NewsCard
                key={n.title}
                news={{
                  ...n,
                }}
              />
            ))}
          </div>
        </div>
      </div>
    </main>
  );
};

export default News;
